module.exports = __webpack_public_path__ + "static/img/Banner.dd23800.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/Banner.svg
// module id = ehAu
// module chunks = 7